import * as React from 'react';
export const useHeightChange = (el, onChange) => {
    const onChangeCb = React.useMemo(() => debounce(onChange), [onChange]);
    React.useEffect(() => {
        const observer = new ResizeObserver((entries) => {
            for (const entry of entries) {
                // each entry is an instance of ResizeObserverEntry
                onChangeCb(entry.contentRect.height);
            }
        });
        if (el) {
            observer.observe(el, { box: 'border-box' });
        }
        return () => observer.disconnect();
    }, [el]);
};
const debounce = (func, waitFor = 300) => {
    let timeout = 0;
    const debounced = (...args) => {
        clearTimeout(timeout);
        setTimeout(() => func(...args), waitFor);
    };
    return debounced;
};
//# sourceMappingURL=use-height-change.js.map